import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HarvestAndPlantingMap from '../HarvestAndPlantingMap';

function PlantingMap(props) {
  return <HarvestAndPlantingMap {...props} />;
}

PlantingMap.propTypes = {
  crop: PropTypes.string.isRequired,
  dates: PropTypes.object.isRequired,
};

function mapStateToProps(state, props) {
  const activeSeason = state.seasons.activeSeasons[props.index];
  const { cropCustomName, plantingEndDate, plantingStartDate, plantingYear } =
    state.seasons.list[activeSeason.id];
  const dates = {
    endDate: plantingEndDate,
    startDate: plantingStartDate,
    year: plantingYear,
  };

  return {
    crop: cropCustomName,
    dates,
  };
}

export default connect(mapStateToProps)(PlantingMap);
